import Creators from './actions';
// import {setStepPagination} from "./actions"
import DataService from '../../common/services/dataService';
import Utils from '../../common/utils/Utils';
import HelperFuncs from './HelperFuncs';

const openCsmModal = Creators.openCsmModal;
const onSearch = Creators.onSearch;
const stepType = Creators.stepType;
const openConfirmBox = Creators.openConfirmBox;
const closeConfirmBox = Creators.closeConfirmBox;
const openEditBox = Creators.openEditBox;
const closeEditBox = Creators.closeEditBox;
const closeModal = Creators.closeModal;
const onDropdownSelect = Creators.onDropdownSelect;
const fetchStepBegin = Creators.fetchStepBegin;
const fetchStepDataSuccess = Creators.fetchStepDataSuccess;
const fetchRawStepDataSuccess = Creators.fetchRawStepDataSuccess;
const addStepError = Creators.addStepError;
const fetchStepError = Creators.fetchStepError;
const editStepError = Creators.editStepError;
const populateFormDropDown = Creators.populateFormDropDown;
const openHamburgerModal = Creators.openHamburgerModal;
const closeHamburgerModal = Creators.closeHamburgerModal;
const onTitleChangeSubmit = Creators.onTitleChangeSubmit;
const editTaskBegin = Creators.editTaskBegin;
const editTaskSuccess = Creators.editTaskSuccess;
const editTaskError = Creators.editTaskError;
const resetStateToLoading = Creators.resetStateToLoading;
const toggleShowNotification = Creators.toggleShowNotification;
const onToggleLockStudy = Creators.onToggleLockStudy;
const addNewItemComplete = Creators.addNewItemComplete;
const openCacheModal = Creators.openCacheModal;
const closeCacheModal = Creators.closeCacheModal;
const getNextButtonOptionsBegin = Creators.getNextButtonOptionsBegin;
const getNextButtonOptionsSuccess = Creators.getNextButtonOptionsSuccess;
const getNextButtonOptionsError = Creators.getNextButtonOptionsError;
const setStepCategory = Creators.setStepCategory;
const setStepPagination = Creators.setStepPagination;
const setUpdateLoading = Creators.setLoading;



const updateLoading = () => {
  return async dispatch => {
    dispatch(setUpdateLoading());

  };
}

const getNextButtonOptions = () => {
  return async dispatch => {
    dispatch(getNextButtonOptionsBegin());
    try {
      const res = await DataService.getNextButton();
      dispatch(getNextButtonOptionsSuccess(res.data));
    }
    catch (err) {
      dispatch(getNextButtonOptionsError(err));
      throw (err);
    }
  };
};

const getIndividualStim = async (id) => {

  try {
    const res = await DataService.fetchSpecificStim(id)
    return res
  }
  catch (err) {
    throw (err);
  }
};


const getStepData = (id) => {
  return async dispatch => {
    try {
      dispatch(fetchStepBegin());
      const res = await DataService.fetchStepData(id);
      const sortedTask = Utils.sortedTaskData(res.data.data);
      const sortedStepData = Utils.sortStepData(res.data.data);
      const newData = Utils.createSortedDataForDragAndDrop(sortedTask, sortedStepData)
      dispatch(fetchRawStepDataSuccess(res.data));
      dispatch(fetchStepDataSuccess(newData));

    }
    catch (err) {
      dispatch(fetchStepError(err));
      throw (err);
    }
  };
};

const onDragEnd = (result) => {
  const studyId = localStorage.getItem('studyId');
  return async (dispatch, getState) => {
    const locked = getState().cellStepManagement.rawCellData.allow_step_editing
    if (!locked) return false;

    const { destination, source, draggableId } = result;
    if (!destination) {
      return;
    }

    if (destination.droppableId === source.droppableId && destination.index === source.index) {
      return;
    }

    const start = getState().cellStepManagement.cellData.columns[source.droppableId];
    const finish = getState().cellStepManagement.cellData.columns[destination.droppableId];
    const tasks = getState().cellStepManagement.cellData.tasks

    if (start === finish) {
      const data = Utils.sortReOrderDataForApi(start, finish, tasks, source, destination, draggableId);

      await DataService.postStepReOrderData(studyId, data);
      const response = await DataService.fetchStepData(studyId);
      const sortedStepData = Utils.sortStepData(response.data.data);
      const sortedTask = Utils.sortedTaskData(response.data.data);
      const sortedDataForDragAndDrop = Utils.createSortedDataForDragAndDrop(sortedTask, sortedStepData);
      dispatch(fetchStepDataSuccess(sortedDataForDragAndDrop));
      dispatch(savedNotification());
    }
  };
};

const onSelectItem = (
  item, //can be "cache page", "stim" etc
  id,
  searchTerm = "",
  resultsPerPage = 25,
  pageNum = 1,
  approved,
  extraFilters = {}
) => {
  const dropDownType = HelperFuncs.returnDropDownType(item); //converts into dropdown type backend can understand in helperfunction

  return async (dispatch, getState) => {
    dispatch(stepType(dropDownType.item));
    dispatch(onDropdownSelect(dropDownType.type)); //save to redux

    const safeResultsPerPage =
      !resultsPerPage || Number(resultsPerPage) < 1
        ? 25
        : Number(resultsPerPage);

    const safePageNum =
      !pageNum || Number(pageNum) < 1 ? 1 : Number(pageNum);

    const data = {
      search_term: searchTerm,
      results_per_page: Number(safeResultsPerPage),
      page_num: Number(safePageNum),
      language_id: extraFilters.language_id || null,
      location_id: extraFilters.location_id || null,
    };

    if (approved === true || approved === false) {
      data.approved = approved;
    }

    console.log("Reusable cache payload →", {
      approved,
      approvedType: typeof approved,
      data,
    });
    if (
      dropDownType.item === "instruction" ||
      dropDownType.item === "cache" ||
      dropDownType.item === "reusable_cache" ||
      dropDownType.item === "question" ||
      dropDownType.item === "external" ||
      dropDownType.item === "embedded" ||
      dropDownType.item === "stim" ||
      dropDownType.item === "individualStim" ||
      dropDownType.item === "command" ||
      dropDownType.item === "distraction"
    ) {
      let res;

      try {
        switch (dropDownType.item) {
          case "instruction":
            res = await DataService.getInstructionSteps(id, data);
            break;

          case "cache":
            res = await DataService.getCacheSteps(id, data);
            break; //list of cache pages

          case "reusable_cache":
            res = await DataService.getReusableCacheSteps(id, data);
            break;

          case "question":
            res = await DataService.getQuestionSteps(id, data);
            break;

          case "external":
            res = await DataService.getExternalSteps(id, data);
            break;

          case "embedded":
            res = await DataService.getEmbeddedSteps(id, data);
            break;

          case "stim":

            const stimData = {
              filters: [
                {
                  group: 'SearchStims',
                  filter: searchTerm,

                }
              ],
              results_per_page: Number(safeResultsPerPage),
              page_num: Number(safePageNum),
              language_id: extraFilters.language_id || null,
              location_id: extraFilters.location_id || null,
            };



            res = await DataService.getStimSteps(id, stimData);
            break;

          case "distraction":
            res = await DataService.getDistractionSteps(id, data);
            break;

          case "command":
            res = await DataService.getCommandSteps(id, data);
            break;

          case "validation":
            res = await DataService.getValidationSteps(id, data);
            break;

          case "calibration":
            res = await DataService.getCalibrationSteps(id, data);
            break;

          default:
            return false;
        }

        const sortedData =
          dropDownType.item === "stim" || dropDownType.item === 'individualStim'
            ? await Utils.createSortedItems(res.data)
            : res.data.data;

        dispatch(populateFormDropDown(sortedData));
        dispatch(
          setStepPagination({
            result_count: res.data.result_count,
            page_num: res.data.page_num,
            results_per_page: res.data.results_per_page,
            total_page_num: res.data.total_page_num,
          })
        );
      } catch (err) {
        dispatch(fetchStepError(err));
        throw err;
      }
    } else {
      return false;
    }
  };
};




const seperateIdAndValue = (value) => {
  const obj = {};
  const valueArray = value.split(':');
  let string = valueArray.shift();
  string.trim();
  obj.step_id = parseInt(valueArray.pop(), 10);
  obj.value = string;
  return obj;
};

const createNewDataObject = (id, value, stepOrder, stepType, stepIdAndValue, secondaryData, name, newItem, param, contents = {}) => {
  let data = {};
  switch (stepType) {
    case 'External':
      if (newItem === true) {
        data = { step_order: stepOrder, step_type: stepType.toLowerCase(), cell_id: parseInt(id, 10), external_url: value, member_insert: secondaryData, name: name }
      } else {
        data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: stepType.toLowerCase(), external_page_id: secondaryData }
      }
      break;
    case 'Embedded':
      if (newItem === true) {
        data = { step_order: stepOrder, step_type: stepType.toLowerCase(), cell_id: parseInt(id, 10), external_url: value, member_insert: secondaryData, name: name };
      } else {
        data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: stepType.toLowerCase(), embedded_page_id: secondaryData };
      }
      break;
    case 'Validation':
      data = { step_order: stepOrder, step_type: stepType.toLowerCase(), cell_id: parseInt(id, 10) };
      break;
    case 'Calibration':
      data = { step_order: stepOrder, step_type: stepType.toLowerCase(), cell_id: parseInt(id, 10) };
      break;
    case 'Instruction':
      if (newItem === true) {
        const localized = Object.fromEntries(
          Object.entries(contents).map(([lang, val]) => {
            if (lang === "default") return ["content", val];
            return [`content_${lang}`, val];
          })
        );

        data = {
          step_order: stepOrder,
          cell_id: parseInt(id, 10),
          step_type: stepType.toLowerCase(),
          name,
          template: param,
          image_src: secondaryData,
          ...localized
        };
      } else {
        data = {
          step_order: stepOrder,
          cell_id: parseInt(id, 10),
          step_type: stepType.toLowerCase(),
          instruction_id: secondaryData
        };
      }
      break;

    case 'Cache Page':
      data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: 'cache', cache_page_id: secondaryData };
      break;// create new data/ payload 
    case 'Reusable Cache Page':
      data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: 'cachepage', cache_page_id: secondaryData };
      break;
    case 'Stim':
      data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: stepType.toLowerCase(), stim_id: secondaryData };
      break;
    case 'Question':
      data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: stepType.toLowerCase(), question_group_id: secondaryData };
      break;
    case 'Command':
      data = { step_order: stepOrder, cell_id: parseInt(id, 10), step_type: stepType.toLowerCase(), command_id: parseInt(secondaryData) };
      break;
    case 'Distraction':
      data = { step_order: stepOrder, cell_id: parseInt(id, 10), stim_id: secondaryData };
      break;
    default:
      data = {};
  }

  return data;
};

const addTask = (id, value, study, stepType, secondaryData, name, newItem, cell_id) => {
  const studyId = study || localStorage.getItem("studyId");
  if (!studyId || studyId === "undefined" || studyId === "") {
    console.error("addTask: missing studyId", { study, fromLS: localStorage.getItem("studyId") });
    throw new Error("Missing studyId");
  }

  if (!id || id === "undefined") {
    console.error("addTask: missing cell/column id", { id });
    throw new Error("Missing cell id");
  }

  const columnId = parseInt(id, 10);

  if (Number.isNaN(columnId)) {
    console.error("addTask: invalid column id", { id });
    throw new Error("Invalid cell id");
  }
  const stepIdAndValue = seperateIdAndValue(value);

  return async (dispatch, getState) => {
    const locked = getState().cellStepManagement.rawCellData.allow_step_editing;
    if (!locked) return false;

    let column;
    if (getState().cellStepManagement.cellData.columns[columnId] === undefined) {
      column = {
        id: columnId,
        taskIds: []
      };
    } else {
      column = getState().cellStepManagement.cellData.columns[columnId];
    }

    const stepOrder = column.taskIds.length;

    const newCellOrder = column.taskIds.map((item, index) => {
      return { index: index, step_order_id: item.step_order_id };
    });

    const data = {};
    data[columnId] = newCellOrder;

    /// crafting 
    let newData = createNewDataObject(
      columnId,
      value,
      stepOrder,
      stepType,
      stepIdAndValue,
      secondaryData,
      name,
      newItem,
      getState().cellStepManagement.param || "",
      getState().cellStepManagement.contents || {}
    );

    try {
      await DataService.postStepReOrderData(studyId, data);

      let createRes;

      if (stepType === "Embedded") {
        createRes = await DataService.postNewEmbeddedStepDataToApi(studyId, newData);
      } else if (stepType === "External") {
        createRes = await DataService.postNewExternalStepDataToApi(studyId, newData);
      } else if (stepType === "Distraction") {
        createRes = await DataService.postNewDistractionStepDataToApi(studyId, newData);
      } else if (stepType === "Instruction") {
        createRes = await DataService.postNewInstructionStepDataToApi(studyId, newData);
      } else {
        createRes = await DataService.postNewStepDataToApi(studyId, newData); //send new cache page step to backend
      }

      const createData = createRes?.data || createRes;

      if (createData && createData.success === false) {
        return createRes;
      }

      const response = await DataService.fetchStepData(studyId);
      const cells = response?.data?.data || [];
      const cell = cells.find((c) => String(c.cell_id) === String(columnId));
      const steps = cell?.step_data || [];

      console.log("[ADD reusable_cache] steps in cell after fetch:", steps.map(s => ({
        step_order_id: s.step_order_id,
        step_type: s.step_type,
        cache_page_id: s.cache_page_id,
        stim_id: s.stim_id,
      })));

      const sortedStepData = Utils.sortStepData(response.data.data);
      const sortedTask = Utils.sortedTaskData(response.data.data);
      const sortedDataForDragAndDrop = Utils.createSortedDataForDragAndDrop(sortedTask, sortedStepData);

      dispatch(addNewItemComplete());
      dispatch(savedNotification());
      dispatch(fetchStepDataSuccess(sortedDataForDragAndDrop));

      return createRes;
    } catch (err) {
      throw err;
    }
  };
};


const deleteTask = (id, columnId, studyId) => {
  return async (dispatch, getState) => {

    const locked = getState().cellStepManagement.rawCellData.allow_step_editing
    if (!locked) return false;
    const data = {
      step_order_id: id
    }

    let column = getState().cellStepManagement.cellData.columns[columnId];
    Array.from(column);
    const newCellOrder = column.taskIds.map((item, index) => {
      return { index: index, step_order_id: item.step_order_id }
    })
    const dataOrder = {};
    dataOrder[column.id] = newCellOrder;


    try {
      await DataService.postStepReOrderData(studyId, dataOrder);
      await DataService.deleteStepFromCell(studyId, data);
      const response = await DataService.fetchStepData(studyId);
      const sortedStepData = Utils.sortStepData(response.data.data)
      const sortedTask = Utils.sortedTaskData(response.data.data)
      const sortedDataForDragAndDrop = Utils.createSortedDataForDragAndDrop(sortedTask, sortedStepData)
      dispatch(fetchStepDataSuccess(sortedDataForDragAndDrop))
      dispatch(closeModal())
      dispatch(closeHamburgerModal())
      dispatch(savedNotification())

    }
    catch (error) {
      throw error
    }

  };
};

const addCell = (id, shortName, value) => {
  const data = {
    'cell_name': value,
    'short_name': shortName
  }
  return async (dispatch) => {
    try {
      const action = {
        type: 'SHOW_MODAL',
        modalType: 'ADD_STEP',
      }
      const res = await DataService.addCell(id, data);

      dispatch(openModal(res.data.cell_id, action))
      dispatch(savedNotification())

      return res;
    }

    catch (error) {
      dispatch(addStepError())
      throw error
    }
  }
}

const editTask = (id, title, TYPE, studyId) => {
  return async (dispatch, getState) => {
    const locked = getState().cellStepManagement.rawCellData.allow_step_editing
    if (!locked) return false;
    dispatch(editTaskBegin())
    let data = {}
    if (TYPE === 'SUBTITLE') {
      const cellName = getState().cellStepManagement.cellData.columns[id].cellName
      data = {
        'cell_id': id,
        'cell_name': cellName,
        'short_name': title
      }

    } else {
      const shortName = getState().cellStepManagement.cellData.columns[id].shortName

      data = {
        'cell_id': id,
        'cell_name': title,
        'short_name': shortName
      };
    }

    try {
      const res = await DataService.editTask(studyId, data);
      dispatch(getStepData(studyId));
      dispatch(editTaskSuccess(res));
    }

    catch (error) {
      dispatch(editTaskError());
    }
  };
};

const onTitleChange = (id, title, studyId) => {
  return async (dispatch) => {
    dispatch(editTaskBegin());
    const data = {
      'cell_id': id,
      'cell_name': title,
    };

    try {
      await DataService.editTask(studyId, data);
      dispatch(onTitleChangeSubmit());
    }
    catch (error) {
      dispatch(editTaskError());
    }
  };
};

const editStepData = (showNext, moveNext, nextNext, id, studyId) => {
  return async (dispatch) => {
    const data = {
      'step_order_id': parseInt(id, 10),
      'seconds_before_show_next': parseInt(showNext || 0, 10),
      'seconds_before_move_next': parseInt(moveNext || 0, 10),
      'next_type_id': parseInt(nextNext || 0, 10),
    };

    try {
      await DataService.editStepData(studyId, data);
      dispatch(editTaskSuccess());
      dispatch(getStepData(studyId));
    }

    catch (error) {
      dispatch(editStepError(error));
    }
  };
};

const savedNotification = () => {
  return (dispatch) => {
    dispatch(toggleShowNotification());
    setTimeout(() => {
      dispatch(toggleShowNotification());
    }, 1800);
  };
};

const openModal = (id, action) => {
  return (dispatch) => {
    dispatch(action);
    dispatch(openCsmModal(id));

  };
};

const toggleLockStudy = (id, isLocked) => {
  return async (dispatch) => {
    try {
      await DataService.unlockStudy(id)
      dispatch(getStepData(id))
      dispatch(onToggleLockStudy(isLocked));

    }

    catch (error) {
      throw error
    }

  };
};

const onCachePageSumbit = (url, name, studyId) => {
  return async (dispatch) => {
    const data = {
      url: url,
      name: name
    }
    try {
      await DataService.orderACachePage(data);
      dispatch(onSelectItem('Cache Page', studyId))

    }

    catch (error) {
      throw error
    }
  }
}
const clearPrimarySelection = () => {
  return dispatch => {
    dispatch({ type: "CLEAR_PRIMARY_SELECTION" });
  };
};



export default {
  openModal,
  closeModal,
  onDragEnd,
  onSelectItem,
  getIndividualStim,
  addTask,
  deleteTask,
  getStepData,
  seperateIdAndValue,
  addCell,
  openHamburgerModal,
  closeHamburgerModal,
  openConfirmBox,
  closeConfirmBox,
  openEditBox,
  closeEditBox,
  editTask,
  onTitleChange,
  editStepData,
  resetStateToLoading,
  toggleShowNotification,
  savedNotification,
  toggleLockStudy,
  onSearch,
  openCacheModal,
  closeCacheModal,
  onCachePageSumbit,
  getNextButtonOptions,
  setStepCategory,
  clearPrimarySelection,
  setStepPagination,
  updateLoading,
};


